import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle, Clock } from 'lucide-react';

export const OrderCancellationPolicy = () => {
  return (
    <div className="min-h-screen py-16 bg-[#F9F8F6]" data-testid="order-cancellation-page">
      <div className="container-custom max-w-4xl">
        <div className="mb-12">
          <h1 className="text-4xl md:text-5xl font-heading font-bold mb-4" data-testid="cancellation-title">Order Cancellation Policy</h1>
          <p className="text-lg text-softgrey">We process orders quickly to get your items to you as fast as possible.</p>
        </div>

        <div className="space-y-10">
          <section className="bg-cream p-8 rounded-xl" data-testid="cancellation-section">
            <div className="flex items-center gap-3 mb-4">
              <XCircle className="w-6 h-6 text-coral" />
              <h2 className="text-2xl font-heading font-bold">Cancellation</h2>
            </div>
            <p className="text-softgrey leading-relaxed text-lg">Orders can be cancelled before dispatch.</p>
          </section>

          <section data-testid="how-to-cancel">
            <div className="flex items-center gap-3 mb-4">
              <Clock className="w-6 h-6 text-coral" />
              <h2 className="text-2xl font-heading font-bold">How to Cancel</h2>
            </div>
            <ul className="list-disc list-inside space-y-3 text-softgrey ml-2">
              <li>Contact us immediately with your order number</li>
              <li>If your order hasn't been dispatched yet, we'll do our best to accommodate your request</li>
              <li>Once dispatched, the order cannot be cancelled (but you can return it upon delivery under our <Link to="/returns-policy" className="text-coral hover:underline font-semibold">Returns Policy</Link>)</li>
            </ul>
          </section>
        </div>

        <div className="mt-16 border-t border-border pt-8">
          <p className="text-softgrey text-sm">Need to cancel an order? <Link to="/contact" className="text-coral hover:underline font-semibold">Contact Us</Link> as soon as possible.</p>
        </div>
      </div>
    </div>
  );
};
